import React, { useState, useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import MultiTouchChoice from './components/MultiTouchChoice';

function App() {
  document.body.addEventListener('touchmove', function (e) { e.preventDefault(); });

  const [text, setText] = useState('');
  const handleTouchEnd = (e: any) => {
    console.log('handleTouchEnd ', e)
    // setText('handleTouchEnd ' + Object.keys(e).join(', '))
    // setText('handleTouchEnd ' + Object.keys(e).join(', '))
  }
  const handleTouchStart = (e: any) => {
    console.log('handleTouchStart', e)
    // setText('handleTouchStart ' + Object.keys(e).join(', '))
    setText('handleTouchStart ' + Object.keys(e.targetTouches).length + ' / ' + JSON.stringify((Object.keys(e.targetTouches).map(o => {
      const touch = e.targetTouches[o];

      return {
        identifier: touch.identifier,
        // screenX: touch.screenX,
        // screenY: touch.screenY,
        // clientX: touch.clientX,
        // clientY: touch.clientY,
        // pageX: touch.pageX,
        // pageY: touch.pageY,
        // target: touch.target
      };
    }))));
  }
  const handleTouchMove = (e: any) => {
    setText('handleTouchMove ' + Object.keys(e.targetTouches).length + ' / ' + JSON.stringify((Object.keys(e.targetTouches).map(o => {
      const touch = e.targetTouches[o];

      return {
        identifier: touch.identifier,
        // screenX: touch.screenX,
        // screenY: touch.screenY,
        // clientX: touch.clientX,
        // clientY: touch.clientY,
        // pageX: touch.pageX,
        // pageY: touch.pageY,
        // target: touch.target
      };
    }))));

  }

  return (
    <div className="App">
      {/* <header>

      </header> */}
      {/* <div> */}
      <MultiTouchChoice />
      {/* </div> */}
    </div>
  );
}

export default App;
